var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"underline"}},[_c('ul',[_c('li',{key:_vm.index,class:(_vm.answer, _vm.index) in _vm.answers},[_c('div',{staticClass:"answer-underline"},[_c('p',{class:'answer-edit-' + _vm.index},[_vm._v(" "+_vm._s(_vm.answer.text)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }